// import '../styles/main.scss';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
// import LazyLoad from 'lazyload';
// Import Swiper
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

if (document.querySelectorAll(".lazyload").length > 0) {
    let images = document.querySelectorAll(".lazyload");
    new LazyLoad(images);
}

window.Alpine = Alpine;
window.Swiper = Swiper;
Swiper.use([Navigation, Pagination]);



import { Header } from '../components/header';
Header();

import { MiniCart } from '../components/mini-cart';
MiniCart();


Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();